module.exports = __webpack_public_path__ + "fonts/Poppins-400-devanagari7.64d5f06.woff2";